angular.module('CarsSaraBo').factory('ResourceService', ['$resource', function($resource) {
  return $resource('../rest/resource/:oid/', 
    { oid : '@oid' },
    {
    	update : { method: 'PUT' }
    }
  )}
]);



//////////////////
// WEBPACK FOOTER
// ./public/app/models/resource_service.js
// module id = 862
// module chunks = 3